import React from 'react';
import CharacterEditor from './components/CharacterEditor';

function IllustrationApp() {
  return (
    <>
      <CharacterEditor />
    </>
  );
}

export default IllustrationApp;